import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";


import Heading from "../../../../Common/Heading";
import { toast } from "react-toastify"

import LoadingSpinner from "../../../../Common/LoadingSpinner";

import Add from '@mui/icons-material/Add';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import SaveAlt from '@mui/icons-material/SaveAlt';

import axios from "axios";
import url from "../../../../Common/URL";
import { useConfirm } from 'material-ui-confirm';

import Button from '@mui/material/Button';
import MaterialReactTable from 'material-react-table';
import { IconButton } from "@mui/material";
import { useSelector } from "react-redux";

const ActTransactionComp = () => {

  const confirm = useConfirm();


  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  const [state, setState] = useState({
    uname: sessionStorage.getItem("username"),
  })

  const Columns = useMemo(
    () => [
      { header: 'Name', id: 'name', accessorFn: rowData => `${rowData.fname} ${rowData.lname}` },
      { header: 'Item Name', accessorKey: 'item_name' },
      { header: 'Transaction Type', accessorKey: 'type' },
      { header: 'Created By', id: 'created_by', accessorFn: rowData => `${rowData.creator_fname} ${rowData.creator_lname}` },
      { header: 'Transaction Date', accessorKey: 'acc_trans_date' },
    ],
    [],
  );


  // ------------------------Fetching Transaction table's data-------------------------------------
  useEffect(() => {
    loadTransactions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadTransactions = () => {
    const obj = { uname: state.uname }
    axios.post(url + "php/accounts_transaction/acc_trans.php", obj)
      .then((response) => {
        // console.log(response)
        if (response.data.success) {
          let a = JSON.parse(response.data.data);
          // console.log(a);
          setData(a);
          setLoading(false)
        } else {
          setData([]);
          setLoading(false)
        }
      })
      .catch((err) => console.log(err));
  }

  // ------------------------Deleting Transaction table's data-------------------------------------

  const onDelete = (id, resolve) => {
    //alert(id);
    const delobj = {
      id: id,
      uname: state.uname,
      tokenId: 123,
    };
    axios.post(url + "php/accounts_transaction/delete_acc_trans.php", delobj)
      .then((res) => {
        // console.log(res);
        resolve();
      })
      .catch((err) => console.log(err));
  }

  return (
    <>
      <div className={useSelector(state => state.sidebar.value) ? 'widthWhenSidebarOpen' : 'widthWhenSidebarClose'}>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb Breadcrumb align-items-center">
            <li className="breadcrumb-item"><Link to="/bulletin">Home</Link></li>
            <li className="breadcrumb-item">Accounts</li>
            <li className="breadcrumb-item active" aria-current="page">Accounts Transactions</li>
          </ol>
        </nav>

        <Heading name="Accounts Transactions" />

        <div className="container-fluid mb-5">
          <div className="row my-4">
            <div className="col-12 mx-auto d-flex justify-content-end ">
              <Button variant="contained" onClick={() => navigate("/add-act-trans")} >Add Transaction <Add /></Button>
            </div>
          </div>
          <div className="row">
            <div className="col-12 mx-auto">
              <MaterialReactTable
                state={{ isLoading: loading }}
                columns={Columns}
                data={data}
                enableRowNumbers
                enableRowSelection
                initialState={{ density: 'compact' }}
                enableDensityToggle={false}
                
                getRowId={(originalRow) => originalRow.acc_trans_id}
                muiTableBodyRowProps={({ row }) => ({
                  onClick: (event) => navigate("/edit-act-trans/" + row.id),
                  sx: { cursor: 'pointer' },
                })}

                renderTopToolbarCustomActions={({ table }) => (
                  <IconButton
                    disabled={table.getSelectedRowModel().rows.length ? false : true}
                    onClick={() => {
                      confirm({ title: "Delete Confirmation", description: 'This will delete selected data permanently.' })
                        .then(() => {
                          let selectedRows = table.getSelectedRowModel().rows;
                          // console.log(selectedRows);
                          const delPromise = selectedRows.map((row) => {
                            return new Promise((resolve, reject) => {
                              onDelete(row.id, resolve);
                            })
                          })
                          Promise.all(delPromise).then(() => {
                            loadTransactions();
                            table.resetRowSelection();
                            toast.error(selectedRows.length + " Row(s) Deleted!")
                          });
                        })
                    }}
                  ><DeleteOutline />
                  </IconButton>
                )}
              />
            </div>
          </div>
        </div>

      </div>

    </>
  )

}
export default ActTransactionComp